import React from "react";
import { Route, Routes } from "react-router-dom"; // Just use Routes
import HomePage from "../pages/HomePage";
import MovieDetailPage from "../pages/MovieDetailPage";
import VideoPlayerPage from "../pages/VideoPlayerPage";
import MovieOtherPage from "../pages/MovieOtherPage";
import HistoryMoviePage from "../pages/HistoryMoviePage";
import SortPage from "../pages/SortPage";
const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/trang-chu" element={<HomePage />} />
      <Route path="/phim/:slug" element={<MovieDetailPage />} />
      <Route path="/phim/:slug/:slug" element={<VideoPlayerPage />} />
      <Route path="/nam/:slugValue" element={<SortPage />} />
      <Route path="/the-loai/:slugValue" element={<SortPage />} />
      <Route path="/quoc-gia/:slugValue" element={<SortPage />} />
      <Route path="/:category" element={<MovieOtherPage />} />
      <Route path="/lich-su" element={<HistoryMoviePage />} />
    </Routes>
  );
};

export default AppRouter;
